import React from 'react';

interface ActionButtonProps {
  onClick?: (e: React.MouseEvent) => void;
  variant?: 'default' | 'supreme';
  isAvailable?: boolean;
  isLive?: boolean; 
}

export const ChatButton: React.FC<ActionButtonProps> = ({ 
  onClick, 
  isAvailable = true,
  isLive = false 
}) => {
  const baseStyles = "flex flex-col items-center justify-center p-2 rounded-xl transition-all duration-300";
  
  const activeColorStyles = "bg-green-200 text-green-600 hover:bg-green-300 active:scale-95 group/btn";
  const disabledStyles = "bg-gray-100 text-gray-400 cursor-not-allowed border border-gray-200 opacity-80";

  const canClick = isAvailable && !isLive;
  const finalStyles = `${baseStyles} ${canClick ? activeColorStyles : disabledStyles}`;

  return (
    <button 
      onClick={canClick ? onClick : undefined} 
      disabled={!canClick} 
      className={finalStyles}
      title={isLive ? "Expert is currently in a Live Session" : ""} 
    >
      <svg xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 mb-1 ${canClick ? 'group-hover/btn:scale-110 transition-transform' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
      </svg>
      <span className="text-[10px] font-bold">Chat</span>
    </button>
  );
};